module.exports = __webpack_public_path__ + "media/PLATNOSCI_ZBLIZENIOWE.1d7297c9.mp3";